<template>
    <div style="padding-top: 5rem;">
        <div class="full_loading" v-if="loading">
            <van-loading type="spinner" />
        </div>
        <div class="user_center_header">
            <van-icon name="arrow-left" class="back" @click="$router.go(-1)"/>
            订单详情
        </div>
        <div class="info_detail" v-if="info">
        <div class="info_status">
            <div v-if="info.status == 0">
                <div style="display: flex;align-items: center;">
                    <van-image :src="require('../../assets/bx/acc/order_2.png')" />
                    待支付</div>
            </div>
            <div v-else-if="info.status == 1">
                <span v-if="info.deliver_status == 0">
                    <van-image :src="require('../../assets/bx/acc/order_2.png')" />
                    待发货
                </span>
                <span v-if="info.deliver_status == 1">
                    <van-image :src="require('../../assets/bx/acc/order_1.png')" />
                    交易完成
                </span>
            </div>
            <span v-else-if="info.status == 2">
                <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                支付失败
            </span>
            <span v-else-if="info.status == 3">
                <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                取消订单
            </span>
            <span v-else-if="info.status == 4">
                <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                订单过期
            </span>
            <span v-else-if="info.status == 5">
                <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                发货失败返还
            </span>
        </div>
        <div class="box">
            <p class="tit">{{ app_name }}</p>
            <div class="cont">
                <van-image class="icon" :src="info.icon_url" />
                <div class="info">
                    <p class="p1">交易类型：道具装备</p>
                    <p class="p2">{{info.prop_name}}</p>
                    <p class="p3">{{info.server_name}}2222</p>
                </div>
            </div>
            <div class="price1" v-if="type == 'sell'">
                <p>售价：</p>
                <p style="color: #000;">&yen;&nbsp;{{ info.price }}</p>
            </div>
            <div class="price2" v-if="type == 'sell'">
                <p>扣除服务费：</p>
                <p>&yen;&nbsp;{{ info.charge }}</p>
            </div>
            <div class="price" v-if="type == 'sell'">实收：<i>&yen;&nbsp;</i><span>{{ (Number(info.price) - Number(info.charge)).toFixed(3) }}</span></div>
             <div class="price price_ss" v-if="type == 'buy'">实付款：<i>&yen;&nbsp;</i><span>{{ Number(info.price).toFixed(3) }}</span></div>
        </div>
        <div class="info_msg">
            <div class="tit">订单信息</div>
            <p class="order_num">
                <span><em>订单编号：</em>{{info.order_num}}</span>
                <span class="copy" @click="copy(info.order_num)">复制</span>
            </p>
            <p v-if="info.c_time"><em>创建时间：</em>{{info.c_time}}</p>
            <p v-if="info.pay_time"><em>付款时间：</em>{{info.pay_time}}</p>
            <p v-if="info.deliver_time"><em>发货时间：</em>{{info.deliver_time}}</p>
            
        </div>
        <!-- <p style="padding: 0 1rem" v-if="info.deliver_status == 1">
            <van-icon name="warning" color="var(--theme)" />
            <span style="color:#666;font-size: 1.2rem;margin-left: 0.25rem;">为了您的账号安全，登录后请及时修改您的密码</span>
        </p> -->
        <van-button class="link" color="var(--theme)" v-if="info && (info.deliver_status == 0 && (info.status != 4 && info.status != 5))" @click="kefu">
            <van-image class="icon kefu" :src="require('../../assets/bx/acc/kefu.png')" />
            联系客服
        </van-button>

        <van-button round color="var(--theme)" class="continue_pay" @click="continue_pay(info.price,userData.balance)" v-if="type == 'buy' && info.status == 0">
            继续付款</van-button>
        </div>
    </div>
</template>
<script>
    import crypto from "crypto";
    import Fingerprint2 from 'fingerprintjs2'
    export default {
        data() {
            return {
                info: null,
                app_name: '',
                currentServeTime: '',
                //倒计时  15分钟
                interval_time: 900000,
                // 支付
                pay_type: '',
                pay_amount: '',
                pwd: '',
                num: 0,
                udid: '',
                loading: false
            }
        },
        filters: {
            plusX(str) {
                var x = "****";
                if (str) {
                    if (str.length >= 6) {
                        return str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    } else {
                        return str;
                    }
                }
            },
        },
        mounted() {
            this.getDetail()
        },
        created() {
            this.getTime()
            this.$store.dispatch("getUserData", true);
        },
        computed: {
            differTime() {
                return this.$store.state.differTime
            },
            order_num() {
                return this.$route.query.order_num
            },
            type() {
                return this.$route.query.type
            },
            userData() {
                return this.$store.getters.state.userData || {};
            },
            access_token() {
                return this.$store.state.access_token
            },
            is_pay() {
                return this.$route.query.is_pay || null
            }
        },
        methods: {
            countdown(createtime) {
                let endtime = new Date(createtime.replace(/-/g, '/')).getTime() + this.interval_time;
                let now = new Date(this.currentServeTime).getTime();
                let left = endtime - now;
                return left;
            },
            getTime() {
                var now = new Date();
                this.currentServeTime = new Date(now.valueOf() - this.differTime);
            },
            finish() {
                this.info.status = 3
                this.$forceUpdate()
            },
            copy(order_num) {
                var that = this
                this.$copyText(order_num).then(() => {
                    that.$toast("复制成功");
                });
            },
            kefu() {
                window.location.href = 'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_' + this.userData.user_id + '&phone=' + this.userData.username
            },
            getDetail() {
                var params = {
                    order_num: this.order_num
                }
                if (this.is_pay) params.is_pay = this.is_pay
                this.$Ajax('order/detail', params, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.info = {...rs.data.propInfo,...rs.data.orderInfo}
                        this.$Ajax('game/app-list').then(res => {
                            if (res.code == 200) {
                                var item = res.data.find(item => item.id == this.info.app_id)
                                this.app_name = item.app_name
                            }
                        })
                    }
                })
            },
            //继续支付
            continue_pay(price, balance) {
                var that = this
                this.$store.dispatch("getUserData", true);
                // this.getUdid()
                this.$filterPop({
                    type: 'mixpay',
                    direction: 'up',
                    selection: {
                        price,
                        balance
                    },
                    onSuccess: (e) => {
                        this.pay_type = e.pay_type
                        this.pay_amount = e.pay_amount
                        if(e.pay_type == 2) {
                            this.buy()
                            return
                        }
                        this.$filterPop({
                            type: 'password',
                            direction: 'up',
                            onFunc: (a) => {
                                this.pwd = a.password
                                this.buy()
                            }
                        })
                    }
                })
                // this.$Ajax('order-v2/order', {
                //     app_id: this.orderInfo.app_id,
                //     goods_id: this.orderInfo.goods_id,
                //     account_id: this.orderInfo.account_id,
                //     server_id: this.orderInfo.server_id,
                //     server_name: this.orderInfo.server_name,
                //     role_id: this.orderInfo.role_id,
                //     role_name: this.orderInfo.role_name,
                //     num: this.num
                // }).then(rs => {
                //     if (rs.code == 200) {
                //
                //
                //     }
                // })
            },
            buy() {
                var that = this
                this.loading = true
                var params2 = {
                    order_num: this.order_num,
                    app_id: this.info.app_id,
                    account_id: this.info.account_id,
                    server_id: this.info.server_id,
                    server_name: this.info.server_name,
                    role_id: this.info.role_id,
                    role_name: this.info.role_name,
                    pay_type: this.pay_type,
                    pay_amount: this.pay_amount
                }
                if(this.pwd) {
                    params2.password = this.pwd
                }
                this.$Ajax('order-v2/pay', params2).then(rs => {
                    if (rs.code == 200) {
                        if(this.pay_type == 1) {
                            setTimeout(() => {
                                this.loading = false
                            }, 1000);
                            this.$router.push({
                                name: 'order.status',
                                query: {
                                    order_num: that.order_num,
                                    type: 'props'
                                }
                            })
                            return
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 1000);
                        window.location.href = `${this.$BaseURL}/order-v2/alipay?order_num=${rs.data.balance_order_num}`
                    } else {
                        setTimeout(() => {
                            this.loading = false
                        }, 1000);
                    }
                }).catch(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 1000);
                })
            },
            async getUdid() {
                var that = this
                const fp = await new Promise((resolve) => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component, index) => {
                            if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不     一样
                                return component.value.replace(/\bNetType\/\w+\b/, '')
                            }
                            return component.value
                        })
                        // 生成最终id murmur 
                        // console.log(values,'使用的浏览器信息')  //使用的浏览器信息
                        const udid = Fingerprint2.x64hash128(values.join(''), 31)
                        // console.log(udid,'生成的标识码') //生成的标识码
                        that.udid = udid
                        resolve(udid);
                    })
                })
                return fp;
            },
            uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8,
                    1); // bits 6-7 of the      clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            },
            MD5(value) {
                return crypto.createHash("md5").update(value).digest("hex");
            },
            sign(params = {}) {
                const keys = Object.keys(params).sort();
                const signs = [];
                for (let key of keys) {
                    if (params[key] == null) continue;
                    signs.push(key + '=' + params[key]);
                }
                return this.MD5(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
            },
        },
    }
</script>
<style lang="less" scoped>
   .full_loading {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999999999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
   .user_center_header {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 525px;
        height: 22.5rem;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        z-index: 1;
        padding: 1rem;
        text-align: center;
        color: #fff;
        font-size: 1.7rem;
        .back {
            position: absolute;
            top: 1.5rem;
            left: .8rem;
            font-size: 2rem;
            cursor: pointer;
        }
    }
    .info_detail {
        padding-bottom: 7rem;
        position: relative;
        z-index: 2;
        max-height: calc(var(--vh, 1vh) * 100 - 5rem);
        overflow-y: auto;
    }

    .info_status {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        color: #fff;
        font-size: 1.6rem;
        font-weight: 700;
        padding: 1.4rem 0;
        border-top-left-radius: .5rem;
        border-top-right-radius: .5rem;
        z-index: 101;

        span {
            display: flex;
            align-items: center;
        }

        .van-image {
            width: 2.4rem;
            height: 2.6rem;
            margin-right: .8rem;
        }
    }

    .box {
        position: relative;
        margin: 0 1rem 1.6rem;
        border-radius: 1rem;
        background-color: #fff;
        padding: 1rem;

        .tit {
            font-size: 1.4rem;
            color: #000;
            font-weight: 700;
            margin-bottom: 1rem;
        }

        .cont {
            display: flex;
            align-items: flex-start;
            margin-bottom: 1.8rem;
            .icon {
                width: 9rem;
                height: 9rem;
                border-radius: 1.2rem;
                overflow: hidden;
                margin-right: 1rem;
            }

            .info {
                line-height: 1.6;

                .p1 {
                    font-size: 1.4rem;
                    color: #000;
                    font-weight: 700;
                }

                .p2 {
                    font-size: 1.4rem;
                    color: #000;
                }

                .p3 {
                    font-size: 1.2rem;
                    color: #999;
                }
            }
        }
        .price1,.price2 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #999;
            font-size: 1.4rem;
            margin-bottom: 1.6rem;
        }
        .price {
            text-align: end;
            font-size: 1.4rem;
            color: #000;

            i {
                font-size: 1.2rem;
            }

            span {
                font-size: 1.8rem;
                font-weight: 700;
            }
            &.price_ss {
                margin-top: -4rem;
            }
        }
    }

    .info_msg {
        position: relative;
        margin: 0 1rem 1rem;
        border-radius: 1rem;
        background-color: #fff;
        border-radius: 1rem;
        padding: 1.8rem 1rem;

        .tit {
            font-size: 1.4rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 1.2rem;
        }

        p {
            margin-bottom: .8rem;
            font-size: 1.4rem;
            color: #000;

            span {
                word-break: break-all;
            }

            em {
                color: #9e9e9e;
            }

            &.order_num {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;

                span {
                    flex: 1;
                }

                .copy {
                    flex: unset;
                    font-size: 1.2rem;
                    color: var(--theme);
                    margin-top: 0.2rem;
                    width: 3rem;
                    text-align: center;
                }
            }
        }
    }

    .link {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35.5rem;
        padding: 0;
        border-radius: 1rem;
        overflow: hidden;
        font-size: 1.4rem;

        /deep/.van-button__text {
            display: flex;
            align-items: center;
        }

        .kefu {
            width: 2.4rem;
            margin-right: .5rem;
            margin-bottom: 0.2rem;
        }
    }

    .continue_pay {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        height: 3.4rem;
        padding: 0;
        width: 34.4rem;
        font-size: 1.4rem;
        z-index: 10;
    }

    .left_times {
        display: flex;
        align-items: center;
        font-size: 1.2rem;
        color: #000;

        .van-count-down {
            display: flex;
        }
    }
</style>